function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrustWallet = function SvgTrustWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3375bb",
      fillOpacity: 1
    },
    d: "M28 14c0 7.73-6.27 14-14 14S0 21.73 0 14 6.27 0 14 0s14 6.27 14 14Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M20.871 7.066a.904.904 0 0 1 .91.922c-.043 2.606-.144 4.606-.332 6.184-.183 1.578-.46 2.75-.875 3.7a5.826 5.826 0 0 1-1.035 1.605c-.547.59-1.172 1.02-1.852 1.43-.292.171-.597.343-.91.523a34.24 34.24 0 0 0-2.273 1.379.916.916 0 0 1-1.012 0 34.492 34.492 0 0 0-2.3-1.391 45.98 45.98 0 0 1-.45-.258c-.8-.46-1.52-.906-2.148-1.539a5.487 5.487 0 0 1-1.074-1.543c-.395-.812-.66-1.797-.86-3.074-.262-1.703-.39-3.93-.441-7.016a.902.902 0 0 1 .258-.652.93.93 0 0 1 .652-.27h.375c1.16 0 3.719-.109 5.934-1.832a.914.914 0 0 1 1.117 0c2.21 1.723 4.77 1.836 5.937 1.832M18.836 17.29c.285-.586.52-1.394.703-2.562.215-1.391.344-3.282.406-5.852-1.363-.04-3.71-.3-5.945-1.809-2.238 1.504-4.582 1.766-5.945 1.809.05 2.129.144 3.781.297 5.082.175 1.477.425 2.48.738 3.184.203.468.433.804.703 1.101.363.399.824.727 1.45 1.106.257.156.546.316.855.492.554.316 1.191.676 1.898 1.125.7-.442 1.324-.797 1.871-1.11.168-.097.324-.183.473-.273.77-.441 1.34-.809 1.765-1.238.286-.293.516-.614.73-1.055"
  }));
};
export default SvgTrustWallet;